import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

import HeaderMenu from '../HeaderMenu';
import logo from '../../../assets/imgs/logo.svg';

import { MenuItems } from '../../../constants';

import './index.scss';

const menuItems = MenuItems;

const Header = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const body = document.body;

    if (open) {
      body.classList.add('non-scroll');
    } else {
      body.classList.remove('non-scroll');
    }
  }, [open]);

  return (
    <header className="header-content-wrap">
      <div className="wrapper">
        <Link to="/home" className="logo">
          <img alt="bme-logo" src={logo}/>
        </Link>
        <span onClick={() => setOpen(prev => !prev)} className={`menu-icon ${open ? 'open-menu' : ''}`}><span/></span>
        <HeaderMenu onChange={() => setOpen(false)} menuItems={menuItems} loggedIn={false}/>
      </div>
    </header>
  )
};

export default Header;
